import thunk from 'redux-thunk';
import reducers from 'reducers';
import { createStore } from 'reducers';
import { applyMiddleware } from 'redux';

const store = createStore(reducers, applyMiddleware(thunk));

export default store;
